namespace Matrix.Data {

	@Serenity.Decorators.responsive()
	@Serenity.Decorators.panel()
	export class SecurityHoldingDialog extends Serenity.TemplatedDialog<any> {

        public grid: SecurityHoldingGrid;

        constructor() {
            super();

			this.grid = new SecurityHoldingGrid(this.element.children());
        }

        protected getTemplate() {
			return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}